<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { $api } from '@/services';
import router from '@/router';

const store = useStore();
const props = defineProps(['form', 'open', 'type']);
const name = ref(props.form?.name || '');
const emit = defineEmits(['close']);

const submit = async () => {
	try {
		const res = props.form
			? await $api.form.changeFormName(props.form.id, {
					assessment_form: {
						name: name.value,
					},
			  })
			: await $api.form.createForm({
					assessment_form: {
						name: name.value,
					},
			  });
		if (res) {
			await store.dispatch('setAlertMessage', {
				message: props.form
					? 'Đổi tên biểu mẫu thành công'
					: 'Tạo biểu mẫu thành công',
				type: 'success',
			});
			emit('close');
			if (!props.form)
				router.push('/form-evaluation/create/' + res.data.data.id);
		}
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
</script>
<template>
	<div class="_invite-employee _modal bg-white">
		<div
			class="
				_modal__content
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					src="@/assets/images/illustrations/edit.png"
					alt="Luca Education"
					title="Luca Education"
					height="60"
					width="60"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
				"
			>
				{{
					props.type === 'edit'
						? 'Chỉnh sửa tên biểu mẫu'
						: 'Tạo biểu mẫu mới'
				}}
			</div>
			<div class="w-full mt-10">
				<div class="input-group flex items-center">
					<div
						class="
							input-group__label
							text-neutral-400
							font-semibold
							w-2/5
							uppercase
						"
					>
						Tên biểu mẫu
					</div>
					<input
						type="text"
						placeholder="Nhập tên biểu mẫu"
						v-model="name"
					/>
				</div>
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				Thoát
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				:disabled="!name"
				@click="submit"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>
